import { AxiosResponse } from 'axios';
import { axiosInstance } from '../../helpers/api_helper';

export interface SubscribeData {
    id: number;
    pageID: string;
    pageName: string;
    pageContent: string;
    createdBy: string;
    updatedBy: string;
    updated: string;
    createdAt: string;
    pageStatus: number;
}

async function getSubscribeData(): Promise<SubscribeData | undefined> {
    const apiUrl = '/FrontPage/Page/0dd86c82-b3c7-45e6-8f4f-59d23273f16c';

    try {
        const response: AxiosResponse<{ data: SubscribeData }> = await axiosInstance.get(apiUrl);

        // Log the entire response data
        console.log('About Us Page Response Data:', response.data);

        // Extract and return the about us page information
        return response.data.data;
    } catch (error: any) {
        console.error('Error fetching About Us page:', error.message);
        // Handle errors here
        throw error;
    }
}

export { getSubscribeData };
